import Wallet from 'assets/icons/wallet/Wallet.svg';
import WalletFill from 'assets/icons/wallet/Wallet-fill.svg';
import Download from 'assets/icons/wallet/Download.svg';
import DownloadFill from 'assets/icons/wallet/Download-fill.svg';
import Upload from 'assets/icons/wallet/Upload.svg';
import UploadFill from 'assets/icons/wallet/Upload-fill.svg';
import { WalletActions } from '../../interfaces';

export const walletPageData = [
    {
        label: 'کیف پول من',
        icon: Wallet,
        iconFill: WalletFill,
        action: WalletActions.Mine
    },
    {
        label: 'واریز',
        icon: Download,
        iconFill: DownloadFill,
        action: WalletActions.Deposit
    },
    {
        label: 'برداشت',
        icon: Upload,
        iconFill: UploadFill,
        action: WalletActions.Withdrawal
    },
];
